/** Chainable service pipe, centred so neighbouring 2.4 m modules meet exactly. */
import * as THREE from 'three';
import { surface } from '../materials';
import type { AssetDefinition } from '../types';

function build(): THREE.Group {
  const group = new THREE.Group();
  group.name = 'pipe-run';
  const pipe = new THREE.Mesh(new THREE.CylinderGeometry(0.04, 0.04, 2.4, 10, 1), surface('metal', 0x9aa5a5));
  pipe.name = 'service-pipe'; pipe.rotation.x = Math.PI / 2; pipe.position.y = 0.47; pipe.castShadow = true;
  group.add(pipe);
  // The cylinder caps land at local z=-1.2 and +1.2. Keeping them flush rather
  // than adding proud collars is what lets instances share an end plane without
  // a visible overlap or a creeping gap down the hall.
  for (const z of [-0.72, 0.72]) {
    const bracket = new THREE.Group(); bracket.name = `pipe-bracket-${z < 0 ? 'back' : 'front'}`;
    const riser = new THREE.Mesh(new THREE.BoxGeometry(0.045, 0.43, 0.035), surface('metal', 0x758081));
    riser.name = 'bracket-riser'; riser.position.y = 0.215;
    const saddle = new THREE.Mesh(new THREE.BoxGeometry(0.14, 0.03, 0.06), surface('metal', 0x758081));
    saddle.name = 'bracket-saddle'; saddle.position.y = 0.43;
    const foot = new THREE.Mesh(new THREE.BoxGeometry(0.16, 0.02, 0.1), surface('metal', 0x758081));
    foot.name = 'bracket-foot'; foot.position.y = 0.01;
    bracket.position.z = z; bracket.add(riser, saddle, foot); group.add(bracket);
  }
  return group;
}

export const pipeRunAsset: AssetDefinition = {
  id: 'pipe-run', label: 'Pipe run', description: '2.4 m galvanized service pipe with two floor brackets and flush chainable ends.',
  footprint: { width: 0.16, height: 0.51, length: 2.4 }, create: build,
};
